module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/react-popper/~/prop-types/lib/has.js
// module id = 866
// module chunks = 0